export default "__VITE_ASSET__BNWEYZmE__"